var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNote = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4756 11.1911L11.1822 15.4844C10.8533 15.8133 10.4 16 9.92889 16H1.77778C0.8 16 0 15.2 0 14.2222V1.77778C0 0.8 0.8 0 1.77778 0H14.2222C15.2 0 16 0.8 16 1.77778V9.92889C16 10.4 15.8133 10.8533 15.4756 11.1911ZM3.55556 12.4444H9.77778V10.6667H3.55556V12.4444ZM12.4444 3.55556H3.55556V5.33333H12.4444V3.55556ZM12.4444 7.11111H3.55556V8.88889H12.4444V7.11111Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNote, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Note.30ac0e8c.svg";
export { ForwardRef as ReactComponent };